export enum PRODUCT_ROUTE {
  PARKING = 'parking',
  LOUNGES = 'lounges',
  MEILI = 'meili',
  MEILI_MANAGE = 'manage',
  EURAIL = 'eurail',
  STOPOVER = 'stopover',
}

const routes = {
  BASE: '/',

  PARKING_SEARCH: `/${PRODUCT_ROUTE.PARKING}/search`,
  PARKING_SEARCH_RESULTS: `/${PRODUCT_ROUTE.PARKING}/results`,
  PARKING_PDP: `/${PRODUCT_ROUTE.PARKING}/product`,
  PARKING_TIP: `/${PRODUCT_ROUTE.PARKING}/booking/passengers`,
  PARKING_PIP: `/${PRODUCT_ROUTE.PARKING}/booking/pay`,
  PARKING_BCP: `/${PRODUCT_ROUTE.PARKING}/booking/confirmation`,

  LOUNGES_SEARCH: `/${PRODUCT_ROUTE.LOUNGES}/search`,
  LOUNGES_SEARCH_RESULTS: `/${PRODUCT_ROUTE.LOUNGES}/results`,
  LOUNGES_PDP: `/${PRODUCT_ROUTE.LOUNGES}/product`,
  LOUNGES_TIP: `/${PRODUCT_ROUTE.LOUNGES}/booking/passengers`,
  LOUNGES_PIP: `/${PRODUCT_ROUTE.LOUNGES}/booking/pay`,
  LOUNGES_BCP: `/${PRODUCT_ROUTE.LOUNGES}/booking/confirmation`,

  MEILI_CAR_RENTAL: `/car-rental/${PRODUCT_ROUTE.MEILI}`,
  MEILI_CAR_RENTAL_MANAGE: `/car-rental/${PRODUCT_ROUTE.MEILI_MANAGE}`,

  EURAIL_SEARCH: `/${PRODUCT_ROUTE.EURAIL}/search`,
  EURAIL_SEARCH_RESULTS: `/${PRODUCT_ROUTE.EURAIL}/results`,
  EURAIL_TIP: `/${PRODUCT_ROUTE.EURAIL}/booking/passengers`,
  EURAIL_PIP: `/${PRODUCT_ROUTE.EURAIL}/booking/pay`,
  EURAIL_BCP: `/${PRODUCT_ROUTE.EURAIL}/booking/confirmation`,

  STOPOVER_LANDING_OFFERS: `/${PRODUCT_ROUTE.STOPOVER}/offers`,
  STOPOVER_LANDING_VERIFY: `/${PRODUCT_ROUTE.STOPOVER}/verify`,
};

export default routes;
